import Loader from './Loader'

Loader.install = (Vue, options) => {
    Vue.prototype.$loader = new (Vue.extend(Loader))({ propsData: options })
    Vue.loader = Vue.prototype.$loader
}

export default Loader
